import { render, staticRenderFns } from "./teacherLessons.vue?vue&type=template&id=13789eb2&"
import script from "./teacherLessons.vue?vue&type=script&lang=js&"
export * from "./teacherLessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports